import React from 'react'
import { Toast, ToastContainer } from 'react-bootstrap'

const COLORES = { 1: '#4CAF50', 11: '#fc9d03', '-1': '#dc3545' }
const TITULOS = { 1: 'Excel generado', 11: 'Atención', '-1': 'Error' }

/** Aviso flotante con el resultado de una exportación de casos (RG-602). `aviso` = `{ code, message }`. */
const AvisoExportacion = ({ aviso, onClose }) => (
    <ToastContainer position='top-end' className='p-3' style={{ position: 'fixed', zIndex: 1080 }}>
        <Toast onClose={onClose} show={Boolean(aviso)} delay={5000} autohide>
            <Toast.Header style={{ backgroundColor: COLORES[aviso?.code] || COLORES['-1'], color: 'white' }}>
                <strong className='me-auto'>{TITULOS[aviso?.code] || TITULOS['-1']}</strong>
            </Toast.Header>
            <Toast.Body>{aviso?.message}</Toast.Body>
        </Toast>
    </ToastContainer>
)

export default AvisoExportacion
